import { useEffect, useRef } from 'react';

interface DataStreamProps {
  snippets: string[];
  isActive: boolean;
}

export default function DataStream({ snippets, isActive }: DataStreamProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && isActive) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [snippets, isActive]);

  if (snippets.length === 0) {
    return (
      <div className="h-20 flex items-center justify-center">
        <span className="text-xs text-ti-text-dim font-mono">
          Awaiting data...
        </span>
      </div>
    );
  }

  return (
    <div className="relative h-24 overflow-hidden rounded-md bg-ti-bg/50">
      <div
        ref={containerRef}
        className={`h-full overflow-hidden px-3 py-2 custom-scrollbar ${
          isActive ? 'animate-pulse' : ''
        }`}
      >
        <div
          className={`space-y-1 ${
            isActive ? 'animate-[data-scroll_8s_linear_infinite]' : ''
          }`}
        >
          {snippets.map((snippet, i) => (
            <pre
              key={i}
              className="text-[10px] leading-tight font-mono text-ti-cyan/70 whitespace-pre-wrap break-all"
            >
              {snippet}
            </pre>
          ))}
        </div>
      </div>
      {/* Gradient fade at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-ti-surface to-transparent pointer-events-none" />
      {/* Gradient fade at top */}
      {isActive && (
        <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-ti-surface to-transparent pointer-events-none" />
      )}
    </div>
  );
}
